<template>
    <section class="notenart">
        <b-alert variant="danger" :show="validation ? true : false">
            Beim Anlegen der Notenarten kam es zu Problemen:
            <ul>
                <li v-for="(item, key) in validation" :key="key">{{item[0]}}</li>
            </ul>
        </b-alert>
        <b-table-simple :refresh="refresh" class="notenart-table" responsive>
            <b-thead>
                <b-tr>
                    <b-th>Ausgabe</b-th>
                    <b-th class="anzahl">Anzahl</b-th>
                    <b-th class="archivnr">Archiv-Nr.</b-th>
                    <b-th class="preis">Preis pro Note</b-th>
                    <b-th>Geliehen</b-th>
                    <b-th>Geliehen von</b-th>
                    <b-th>
                        <font-awesome-icon icon="trash" />
                    </b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="item in items" :key="item.code">
                    <b-th>{{item.description}}</b-th>
                    <b-td colspan="7" class="p-0">
                        <EndlessTable
                            v-model="item.parts"
                            colspan="7"
                            newItemButtonText="+"
                            :newItemBoilerplate="{notentyp: item.code}"
                            :busy="busyParts"
                            :small="true"
                            @update="update"
                        >
                            <template v-slot="{item: parts}">
                                <b-td class="anzahl">
                                    <b-input-group size="sm">
                                        <b-input
                                            v-model="parts.anzahl"
                                            placeholder="Anzahl"
                                            @change="changeNote(parts.id, item.code)"
                                        />
                                        <b-input-group-append
                                            v-if="parts.changeNote"
                                            is-text
                                            v-b-tooltip.hover
                                            title="Eine Veränderung der Notenanzahl im Archiv kann zu weitreichenden Folgen führen. Bitte achten Sie darauf das die hier eingetragenen Werte dem aktuellen Archivbestand widerspiegeln sollte, inklusive aller im Umlauf befindlich Noten"
                                        >
                                            <font-awesome-icon
                                                icon="exclamation-triangle"
                                                class="text-warning"
                                            />
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-td>
                                <b-td class="archivnr">
                                    <b-input
                                        v-model="parts.archivnr"
                                        size="sm"
                                        placeholder="Archiv-Nr."
                                    />
                                </b-td>
                                <b-td class="preis">
                                    <b-input-group size="sm">
                                        <b-input
                                            v-model="parts.preis"
                                            class="text-right"
                                            placeholder="Preis"
                                        />
                                        <b-input-group-append is-text>€</b-input-group-append>
                                    </b-input-group>
                                </b-td>
                                <b-td class="geliehen">
                                    <b-radio-group
                                        buttons
                                        button-variant="outline-secondary"
                                        v-model="parts.geliehen"
                                        :options="rentalOptions"
                                        size="sm"
                                    />
                                </b-td>
                                <b-td>
                                    <b-input
                                        v-model="parts.geliehen_von"
                                        :disabled="parts.geliehen != 1"
                                        placeholder="Geliehen von"
                                        size="sm"
                                    />
                                </b-td>
                            </template>
                        </EndlessTable>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </section>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import { ApiFactory } from "@/api/ApiFactory.js";
import EndlessTable from "@/components/EndlessTable/EndlessTable";

import "./Notenart.scss";

const NotenverwaltungApi = ApiFactory.get("notenverwaltung");

export default {
    name: "Notenart",
    props: ["id", "validation"],
    components: {
        EndlessTable
    },
    mixins: [CommonView],
    data() {
        return {
            api: NotenverwaltungApi,
            refresh: false,
            busyParts: false,
            rentalOptions: [
                { text: "ja", value: 1 },
                { text: "nein", value: 0 }
            ]
        };
    },
    watch: {
        items: {
            async handler(val) {
                this.busyParts = true;
                const collection = await this.fetchNotenArt();
                for (var item of val) {
                    const matchingParts = collection.filter(
                        part => part.notentyp === item.code
                    );
                    item.parts = matchingParts;
                }
                this.refresh = !this.refresh;
                this.busyParts = false;
                this.update();
            },
            deep: true
        },
        validation: {
            handler(val) {
                console.log(val);
            }
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await this.api.getNotentyp();
            if (response.ok) {
                var items = response.json.collection;
                items = items.map(item => this.process(item));
                this.items = items;
                this.registerRights(response);
            }
            this.busy = false;
        },
        async fetchNotenArt() {
            const response = await this.api.getNotenart(this.id);
            if (response.ok && response.json.collection) {
                var items = response.json.collection.map(item => {
                    item.changeNote = false;
                    return item;
                });
                return items;
            } else {
                return [];
            }
        },
        update() {
            const parts = [].concat(
                ...this.items.map(({ parts }) => parts || [])
            );
            this.$emit("update", parts);
        },
        changeNote(id, notentyp) {
            console.log("amount of " + id + " is changed");
            var item = this.items.find(item => item.code === notentyp);
            var part = item.parts.find(itemPart => itemPart.id === id);
            part.changeNote = true;
        }
    }
};
</script>